/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        define([], factory);
    }
})(this, function () {
    'use strict';

    var BASE64_CHARS =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz0123456789+/';

    return {
        /**
         * Given an array of bits, pack it into a base64 encoded string.
         */
        packMask: function (mask) {
            var buffer = 0,
                result = '',
                i;

            for (i = 0; i < mask.length; i++) {
                buffer |= !!mask[i] << (5 - (i % 6));
                if (i % 6 === 5) {
                    result += BASE64_CHARS[buffer];
                    buffer = 0;
                }
            }
            if (buffer) {
                result += BASE64_CHARS[buffer];
            }
            return result;
        },

        /**
         * Packs the values into a binary structure, and base64 encode.
         *
         * Equivalent to base64.b64encode(struct.pack(fmt, values)) in Python.
         * Only a small subset is implemented so far:
         *     B = unisigned char
         *     H = unisigned short
         *     I = unisigned int32
         */
        pack: function (fmt, values) {
            var buffer = [],
                padding = 0,
                result = '',
                i,
                a,
                b,
                c,
                w,
                x,
                y,
                z;

            for (i = 0; i < fmt.length; i++) {
                switch (fmt[i]) {
                    case 'B':
                        buffer.push(values[i] & 0xff);
                        break;
                    case 'H':
                        buffer.push(values[i] & 0xff);
                        buffer.push((values[i] >> 8) & 0xff);
                        break;
                    case 'I':
                        buffer.push(values[i] & 0xff);
                        buffer.push((values[i] >> 8) & 0xff);
                        buffer.push((values[i] >> 16) & 0xff);
                        buffer.push((values[i] >> 24) & 0xff);
                        break;
                    default:
                }
            }
            while (buffer.length % 3 !== 0) {
                buffer.push(0);
                padding += 1;
            }
            for (i = 0; i < buffer.length; i += 3) {
                a = buffer[i];
                b = buffer[i + 1];
                c = buffer[i + 2];

                w = (a >> 2) & 0x3f;
                x = ((a << 4) | (b >> 4)) & 0x3f;
                y = ((b << 2) | (c >> 6)) & 0x3f;
                z = c & 0x3f;

                result += BASE64_CHARS[w] + BASE64_CHARS[x];
                result +=
                    i + 1 < buffer.length - padding ? BASE64_CHARS[y] : '=';
                result +=
                    i + 2 < buffer.length - padding ? BASE64_CHARS[z] : '=';
            }
            return result;
        },

        /**
         * Modified Fowler Noll Vo Hash
         *
         * http://isthe.com/chongo/tech/comp/fnv/
         * Modified to extract onyl 16 bits.
         */
        fnv16a: function (str) {
            var h = 0x811c9dc5,
                i;

            for (i = 0; i < str.length; i++) {
                h ^= str.charCodeAt(i);
                h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
            }
            // Extract the top 16 bits because FNV avalanche behavior in
            // the lower bits is poor.
            return (h & 0xffff0000) >>> 16;
        },
    };
});
